import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { APP_VERSION } from '@webapp/shared';

@Component({
  selector: 'knx-app-footer',
  imports: [TranslatePipe],
  host: {
    class: 'border-t block border-border bg-background',
  },
  templateUrl: './app-footer.html',
})
export class AppFooter {
  readonly version = inject(APP_VERSION);
}
